var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVisibility = function SvgVisibility(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50033 3.16669C5.54199 3.16669 2.16158 5.62877 0.791992 9.10419C2.16158 12.5796 5.54199 15.0417 9.50033 15.0417C13.4587 15.0417 16.8391 12.5796 18.2087 9.10419C16.8391 5.62877 13.4587 3.16669 9.50033 3.16669ZM9.50033 13.0625C7.31533 13.0625 5.54199 11.2892 5.54199 9.10419C5.54199 6.91919 7.31533 5.14585 9.50033 5.14585C11.6853 5.14585 13.4587 6.91919 13.4587 9.10419C13.4587 11.2892 11.6853 13.0625 9.50033 13.0625ZM9.50033 6.72919C8.18616 6.72919 7.12533 7.79002 7.12533 9.10419C7.12533 10.4184 8.18616 11.4792 9.50033 11.4792C10.8145 11.4792 11.8753 10.4184 11.8753 9.10419C11.8753 7.79002 10.8145 6.72919 9.50033 6.72919Z",
    fill: "#9D9D9D"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVisibility);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/visibility.246b78e428967d190f080dcadd72009d.blank.svg";